ACC.accordion = {

    _autoload: [
        ['init', $('.c-accordion-group').length !== 0 && !ACC.utils.isHedTheme()],
    ],

    init() {
        $('.c-accordion-group .c-accordion__trigger').on('click', function (e) {
            e.preventDefault();

            const $btn = $(this);
            $btn.toggleClass('isActive');
            ACC.accordion.toggleAccordion($btn);
        });

        ACC.accordion.initAccordion();
    },

    initAccordion() {
        const btns = $('.c-accordion__trigger');

        btns.each((_, btn) => {
            const $btn = $(btn);
            ACC.accordion.toggleAccordion($btn);
            ACC.accordion.addAriaControlsAttribute($btn);
        });
    },

    toggleAccordion(btn) {
        if (btn.hasClass('isActive')) {
            btn.attr('aria-expanded', 'true');
            btn.next('.c-accordion-panel').slideToggle('500');
            return;
        }
        btn.attr('aria-expanded', 'false');
        btn.next('.c-accordion-panel').slideUp('500');
    },

    addAriaControlsAttribute(btn) {
        const panelId = btn.next('.c-accordion-panel').attr('id');
        btn.attr('aria-controls', panelId);
    },
};
